/**
 * Initialize interactive authentication on application startup
 * Call this function when the user selects Feide or other OAuth-based authentication
 */
export async function initializeInteractiveAuth(p360Url: string): Promise<void> {
    const { authenticateTo360, setAuthMode } = await import('./authService');

    // Enable interactive auth mode
    setAuthMode(true);
    // Trigger initial authentication
    await authenticateTo360(p360Url, false);
}

/**
 * Initialize token-based authentication (MSAL)
 * This is the default mode
 */
export async function initializeTokenAuth(): Promise<void> {
    const { setAuthMode } = await import('./authService');
    setAuthMode(false);
}

/**
 * Check if user is authenticated
 * For interactive auth, checks session storage
 * For token auth, checks MSAL state
 */
export async function checkAuthStatus(p360Url: string): Promise<boolean> {
    const { isInteractiveAuthEnabled } = await import('./authService');

    if (isInteractiveAuthEnabled()) {
        p360Url = p360Url.endsWith('/') ? p360Url.slice(0, -1) : p360Url;
        const sessionExpiryKey = `${p360Url}_p360SessionExpiry`;
        const sessionExpiry = sessionStorage.getItem(sessionExpiryKey);
        const currentTime = Date.now();

        return sessionExpiry !== null && currentTime < Number.parseInt(sessionExpiry);
    }

    // For token-based auth, check MSAL
    try {
        const { getTokenUnified } = await import('./msalUtil');
        const token = await getTokenUnified();
        return !!token;
    } catch {
        return false;
    }
}
